<template>
  <div class="footer-copyRight">
    <div>版权所有@北京康吉森自动化设备技术有限责任公司</div>
    <div>京ICP备 18061198号-1</div>
  </div>
</template>

<script>
export default {
  name: 'page-footer'
};
</script>
<style scoped lang="less">
.footer-copyRight{
   div {
       margin-bottom:10px;
       display: block;
       text-align: center;
       color:rgba(0,0,0,0.67);
       user-select: none;
       font-size: 14px;
   } 
}
</style>
